import {CommonModule} from '@angular/common';
import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';

import {BasicPlanLimit} from '../models/basic-plan-limit.model';

export interface BasicPlanConfirmationDialogData {
  entitlement: BasicPlanLimit;
}

@Component({
  selector: 'app-basic-plan-confirmation-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule],
  templateUrl: './basic-plan-confirmation-dialog.component.html',
  styleUrl: './basic-plan-confirmation-dialog.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class BasicPlanConfirmationDialogComponent {
  constructor(
    public readonly dialogRef: MatDialogRef<BasicPlanConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: BasicPlanConfirmationDialogData
  ) {
    dialogRef.disableClose = true;
  }

  get isOverLimit(): boolean {
    return this.data.entitlement.used > this.data.entitlement.limit;
  }
}
